import classNames from 'classnames';
import {
    FormattedMessage,
    useIntl,
} from 'react-intl';
import {NavLink} from 'react-router-dom';
import {Routes} from '../../../../Routes';

export function LabReportLink(props) {
    const {className, dataTestId} = props;

    const intl = useIntl();

    const linkClasses = classNames('link', className);

    return (
        <NavLink
            className={linkClasses}
            data-test-id={dataTestId ?? 'account-menu-lab-report-link'}
            title={intl.formatMessage({id: 'accountMenu.link.labReport.title'})}
            to={Routes.ACCOUNT_LAB_REPORT}
        >
            <span>
                <FormattedMessage id={'accountMenu.link.labReport.text'} />
            </span>
        </NavLink>
    );
}
